let registeredModules = {};

function dynamicRequire(module){
    if(registeredModules[module]){
        return registeredModules[module];
    }else{
        throw Error(`Dynamic Module "${module}" not found`);
    }
}

dynamicRequire.register = function(modules){
    registeredModules = {...registeredModules, ...modules};
};

module.exports = dynamicRequire;


// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/dynamicRequire.js